import { emsClient } from '../api/clients';

export async function translateChatMessage(text: string, targetCulture: string): Promise<string> {
  const { data, response } = await emsClient().POST('/portal/v1/translate', {
    body: { text, targetCulture } as never,
  });

  if (data === undefined) {
    throw new Error(`Failed to translate a chat message (HTTP ${response.status})`);
  }

  return (data as unknown as { translatedText: string }).translatedText;
}
